'use strict';

angular.module('ClinicApp').directive('modelSelect', function($document, OCPhotoUtil, OpencareConstants) {
  return {
    require: 'ngModel',
    templateUrl: '/views/directives/_model-select.html',
    scope: {
      models: '=modelSelect',
      modelType: '@', // 'provider', 'clinic'
      onChange: '&',
      label: '@',
      showAllOption: '=',
      multiSelect: '=', // allow the multi-select if true.
    },
    link: function($scope, _el, _attrs, ngModel) {
      $scope.showDropdown = false;
      $scope.multiSelectControl = {
        enabled: false,
        touched: false,
        state: {}, // boolean states by the model ids.
      };

      $scope.toggleDropdown = () => {
        $scope.showDropdown = !$scope.showDropdown;
      };

      $scope.getModelBaseNamePlural = () => {
        if ($scope.modelType === 'provider') {
          return 'Providers';
        } else if ($scope.modelType === 'clinic') {
          return 'Practices';
        }
      };

      $scope.getModelBase = (model) => {
        if ([null, OpencareConstants.allProviders].includes(model) && $scope.showAllOption) {
          return {
            name: `All ${$scope.getModelBaseNamePlural()}`,
            isAllOption: true,
          };
        } else if (!model) {
          return {};
        } else if ($scope.modelType === 'provider') {
          return model.doctor;
        } else if ($scope.modelType === 'clinic') {
          return model;
        }
      };

      $scope.getPhotoSource = (modelBase) => {
        if (modelBase?.isAllOption) {
          return '/img/icons/all-providers.svg';
        }

        let modelType;

        if ($scope.modelType === 'provider') {
          modelType = 'doctor';
        } else if ($scope.modelType === 'clinic') {
          modelType = 'clinic';
        }

        return OCPhotoUtil.primaryPhotoForModel(modelType, modelBase?.primaryPhoto);
      };

      $scope.selectModel = (model) => {
        if ($scope.multiSelectControl.enabled) {
          $scope.multiSelectControl.state[model.id] = !$scope.multiSelectControl.state[model.id];
          $scope.multiSelectControl.touched = true;
        } else {
          $scope.showDropdown = false;
          ngModel.$setViewValue(model);
          $scope.onChange();
        }
      };

      $scope.isSelected = (model) => {
        const selectedModels = Array.isArray(ngModel.$viewValue) ? ngModel.$viewValue : [ngModel.$viewValue];
        return selectedModels.some((selectedModel) => selectedModel && model && selectedModel.id === model.id);
      };

      $scope.getSelectedPhotoSource = () => {
        const selectedModel = Array.isArray(ngModel.$viewValue) ? ngModel.$viewValue[0] : ngModel.$viewValue;
        return $scope.getPhotoSource($scope.getModelBase(selectedModel));
      };

      $scope.getSelectedLabel = () => {
        const selectedModels = Array.isArray(ngModel.$viewValue) ? ngModel.$viewValue : [ngModel.$viewValue];

        if (!selectedModels.length) {
          return;
        }

        let label = $scope.getModelBase(selectedModels[0]).name;

        if (selectedModels.length > 1) {
          label += ` & ${selectedModels.length - 1} other`;
        }

        return label;
      };

      $scope.enableMultiSelect = () => {
        const selectedModel = ngModel.$viewValue;

        if (selectedModel) {
          $scope.multiSelectControl.state = {
            [selectedModel.id]: true,
          };
        }

        $scope.multiSelectControl.touched = false;
        $scope.multiSelectControl.enabled = true;
      };

      $scope.applyMultiSelectIsDisabled = () =>
        !($scope.models ?? []).some((model) => $scope.multiSelectControl.state[model.id]);

      $scope.applyMultiSelect = (selectAll = false) => {
        $scope.showDropdown = false;
        const models = $scope.models ?? [];

        if (selectAll) {
          for (const model of models) {
            $scope.multiSelectControl.state[model.id] = true;
          }
        }

        const selectedModels = models.filter((model) => $scope.multiSelectControl.state[model.id]);
        ngModel.$setViewValue(selectedModels);
        $scope.onChange();
      };

      $scope.resetMultiSelect = () => {
        $scope.multiSelectControl.enabled = false;
        $scope.selectModel($scope.models?.[0]);
      };

      $scope.stopPropagation = (event) => {
        event.stopPropagation();
      };

      function handleOutsideClick() {
        $scope.showDropdown = false;
        $scope.$apply();
      }

      // Clicks outside the dropdown should hide it.
      $document.on('click', handleOutsideClick);
      $scope.$on('$destroy', () => $document.off('click', handleOutsideClick));
    },
  };
});
